import { render, staticRenderFns } from "./AdminInfo.vue?vue&type=template&id=93d3fcfa&scoped=true"
import script from "./AdminInfo.vue?vue&type=script&lang=js"
export * from "./AdminInfo.vue?vue&type=script&lang=js"
import style0 from "./AdminInfo.vue?vue&type=style&index=0&id=93d3fcfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d3fcfa",
  null
  
)

export default component.exports